export namespace Random {
    export function int(a: number, b: number, inclusive: boolean = false) {
        return Math.floor((b - a + (inclusive ? 1 : 0)) * Math.random() + a);
    }

    const strTable = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

    export function string(len: number) {
        let out = '';

        for (let i = 0; i < len; i++) {
            out += strTable[int(0, strTable.length)];
        }

        return out;
    }
}